import { EditableText } from '@shakkerai/pro-components';
import { Tooltip } from '@mantine/core';
import React, { useCallback } from 'react';
import { translate } from '@shakkerai/util-i18n';
import { Icon } from '@shakkerai/components';
import { MAX_GENERATOR_SIZE, MIN_GENERATOR_SIZE } from '@shakkerai/pro-constants';

const labelStyle = { label: { fontSize: '12px' } };

export const SizeInputGroup = React.memo(
  ({ disabled, hideLockButton, maxSize = MAX_GENERATOR_SIZE, value, lockRatio, onChange }) => {
    const ratio = value.width / value.height;
    lockRatio = typeof lockRatio === 'boolean' ? lockRatio : value.lockRatio || false;

    const handleChange = useCallback(
      (value, name) => {
        value = parseInt(value, 10);
        if (isNaN(value)) return;
        value = Math.max(MIN_GENERATOR_SIZE, Math.min(maxSize, value));

        const changedProps = { [name]: value };

        if (lockRatio) {
          if (name === 'width') {
            //
            changedProps.height = value / ratio;
            if (changedProps.height > maxSize) {
              changedProps.height = maxSize;
              changedProps.width = changedProps.height * ratio;
            } else if (changedProps.height < MIN_GENERATOR_SIZE) {
              changedProps.height = MIN_GENERATOR_SIZE;
              changedProps.width = changedProps.height * ratio;
            }
          } else if (name === 'height') {
            changedProps.width = value * ratio;
            if (changedProps.width > maxSize) {
              changedProps.width = maxSize;
              changedProps.height = changedProps.width / ratio;
            } else if (changedProps.width < MIN_GENERATOR_SIZE) {
              changedProps.width = MIN_GENERATOR_SIZE;
              changedProps.height = changedProps.width / ratio;
            }
          }

          changedProps.width = Math.max(MIN_GENERATOR_SIZE, Math.min(maxSize, changedProps.width));
          changedProps.height = Math.max(MIN_GENERATOR_SIZE, Math.min(maxSize, changedProps.height));
        }

        onChange(changedProps);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [ratio, onChange, lockRatio],
    );

    if (disabled) {
      return (
        <div className="flex items-center relative leading-3">
          <div className="h-6 flex items-center">
            <div className="text-[#909090] w-[25px] text-[11px] shrink-0">W</div>
            <span className="text-[#999] text-mini">{value.width}</span>
          </div>
          <div className="h-6 flex items-center ml-4">
            <div className="text-[#909090] w-[25px] text-[11px] shrink-0">H</div>
            <span className="text-[#999] text-mini">{value.height}</span>
          </div>
        </div>
      );
    }

    return (
      <div className="flex items-center justify-between relative leading-3">
        <div className="h-6 flex items-center">
          <div className="text-[#909090] translate-y-px text-[11px] shrink-0">W</div>
          <EditableText
            className="text-center w-[45px]"
            styles={labelStyle}
            name="width"
            value={Math.round(value.width)}
            onChange={handleChange}
          />
        </div>
        <Tooltip position="bottom-end" withArrow className="scale-90" label={translate('lock_ratio')}>
          <button
            disabled={hideLockButton}
            onClick={() => onChange({ lockRatio: !lockRatio })}
            className={`flex items-center justify-center w-5 h-5 disabled:opacity-50 ml-[8px] mr-[12px] rounded-xs ${
              lockRatio ? 'bg-[#F4F6F8] text-[#005848]' : 'text-[#7f7f7f]'
            }`}
          >
            <Icon fontSize={12} className="shk-kuangjia-suo" color="inherit" />
          </button>
        </Tooltip>
        <div className="h-6 flex items-center">
          <div className="text-[#909090] translate-y-px text-[11px] shrink-0">H</div>
          <EditableText
            className="text-center w-[45px]"
            styles={labelStyle}
            name="height"
            value={Math.round(value.height)}
            onChange={handleChange}
          />
        </div>
      </div>
    );
  },
);
